var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilmSmallDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.394,
    height: 13.11,
    viewBox: "0 0 20.394 13.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -85.333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 85.333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.048,86.9a.728.728,0,0,0-.709-.032l-4.773,2.387V87.518a2.185,2.185,0,0,0-2.185-2.185H2.185A2.185,2.185,0,0,0,0,87.518v8.74a2.185,2.185,0,0,0,2.185,2.185h10.2a2.185,2.185,0,0,0,2.185-2.185V94.523l4.773,2.39a.728.728,0,0,0,1.054-.656v-8.74A.728.728,0,0,0,20.048,86.9ZM7.283,94.8A2.913,2.913,0,1,1,10.2,91.888,2.913,2.913,0,0,1,7.283,94.8Z",
    transform: "translate(0 -85.333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilmSmallDark);
export default __webpack_public_path__ + "static/media/icon-film-small-dark.09538ad28c3091d164f4c232cb72a992.svg";
export { ForwardRef as ReactComponent };